import React from 'react';

import CommonImage from '@/components/CommonImage';

const TaskTable = () => {
	return (
		<div className="task-configuration-container px-4 py-2">
			<div className="task-configuration-header d-flex align-items-center justify-content-between">
				<p className="semibold-14 gray_dark_02">Task configuration</p>
				<div className="task-action d-flex align-items-center">
					<div className="form-group size32 m-0 mr-1 search-filter filter-with-animation">
						<div className="with-icon right-icon hidden">
							<input type="text" placeholder="Search" value="" />
							<span className="right-icon">
								<CommonImage src="/icons/search.png" alt="" />
							</span>
						</div>
					</div>
					<div className="add-new-design">
						<button className="button text size32 px-0">
							<CommonImage src="/icons/add-round.svg" alt="add" />
							<span className="ml-1 gray_dark_02">Task</span>
						</button>
					</div>
				</div>
			</div>
			<div className="task-configuration-table mt-3">
				<table className="table with-border scroll-x-label">
					<thead>
						<tr>
							<th>Stage (26)</th>
							<th>SL</th>
							<th>Task</th>
							<th>Completion condition</th>
							<th>Dependency</th>
							<th>Who can complete?</th>
							<th>Not required, if it’s</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td rowSpan={2}>Techpack creation</td>
							<td className="sl-column">1</td>
							<td className="task-column">
								<p>Techpack creation</p>
							</td>
							<td className="condition-column">
								<p>Task</p>
							</td>
							<td className="dependency-column">
								<p>Task</p>
							</td>
							<td className="complete-column">
								<p>Task</p>
							</td>
							<td className="not-required-column">
								<p>Task</p>
							</td>
							<td className="action-column">
								<div className="option">
									<div className="dropdown">
										<button
											aria-expanded="false"
											className="btn btn-default dropdown-toggle"
											data-toggle="dropdown"
											id="menu1"
											type="button"
										>
											<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
										</button>
										<ul
											aria-labelledby="menu1"
											className="dropdown-menu dropdown-menu-right shadow-lg"
											role="menu"
											x-placement="bottom-end"
										>
											<li className="px-4 pb-3 pt-3" role="presentation">
												<a
													className="font-weight-normal  text-black"
													href="/invoices/edit/10052"
													role="menuitem"
													tabIndex={-1}
												>
													Edit
												</a>
											</li>
											<li className="px-4 pb-3" role="presentation">
												<a
													className="font-weight-normal  text-black"
													href
													role="menuitem"
													tabIndex={-1}
												>
													Delete
												</a>
											</li>
										</ul>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>Techpack creation</td>
							<td>Task</td>
							<td>Task</td>
							<td>Task</td>
							<td>Task</td>
							<td>Task</td>
							<td>Task</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default TaskTable;
